import { Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useStart } from "./useStart";

const PLANS = [
  { id: "free", name: "Free", price: "₹0", note: "forever", cta: "Start free", features: ["3 AI replies or photo openers per day", "Screenshot reading & paste", "100+ languages, Rizz Mode & personalities", "Voice notes & read-aloud"] },
  { id: "premium", name: "Premium", price: "₹199", note: "/ 30 days", cta: "Go Premium", next: "/upgrade", features: ["Up to 100 replies & photo openers per day", "Everything in Free", "One-time payment, no auto-renew", "UPI, cards & netbanking"], highlight: true },
];

export const Pricing = () => {
  const start = useStart();
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <section id="pricing" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="max-w-2xl mb-12 space-y-3">
        <div className="eyebrow">Pricing</div>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">Start free. Upgrade when you need more.</h2>
      </div>
      <div className="grid md:grid-cols-2 gap-5 max-w-4xl">
        {PLANS.map((p) => (
          <div key={p.id} data-testid={`pricing-plan-${p.id}`} className={`panel p-8 flex flex-col ${p.highlight ? "ring-1 ring-primary/40" : ""}`}>
            <div className="flex items-baseline justify-between">
              <h3 className="text-xl font-semibold">{p.name}</h3>
              {p.highlight && <span className="text-[11px] uppercase tracking-wider font-semibold text-accent">Most rizz</span>}
            </div>
            <div className="mt-4 mb-6"><span className="font-display text-4xl font-extrabold">{p.price}</span> <span className="text-sm text-muted-foreground">{p.note}</span></div>
            <ul className="space-y-3 text-sm flex-1">
              {p.features.map((f) => (<li key={f} className="flex gap-2"><Check className="h-4 w-4 text-primary mt-0.5 shrink-0" />{f}</li>))}
            </ul>
            <button data-testid={`pricing-cta-${p.id}`} onClick={() => (p.next ? navigate(user ? p.next : "/login") : start())}
              className="mt-8 h-12 rounded-full font-semibold transition-opacity brand-gradient text-white hover:opacity-90">
              {p.cta}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};
